<div class="row">
  <div class="col-12">
    <fieldset
      class="field-group"
      [ngClass]="{
        disabled: disabled,
        hilite: hilite,
      }"
    >
      <legend>Notifications</legend>
      <div class="d-flex justify-content-between full-width pr-2">
        <span
          *ngFor="let n of roleNotifications"
          [matTooltipDisabled]="!n.checked"
          [matTooltip]="getUsersTooltip(n)"
        >
          <mat-checkbox
            [ngClass]="{ hilite: n.changed }"
            [(ngModel)]="n.checked"
            [disabled]="disabled ?? false"
            (ngModelChange)="onCheckboxChange()"
            color="primary"
          >
            {{ n.name }}
          </mat-checkbox>
        </span>
      </div>
    </fieldset>
  </div>
</div>
